import AuthContext from 'app/frontend/base/config/context/auth'
import { hasAccessToContent } from 'app/frontend/base/config/permissions'
import { GuildTeamData } from 'app/frontend/base/api/guild'
import {
  linkedTeamGroups,
  linkedTeamHref,
} from 'app/frontend/base/helpers/linkedGuilds'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import { useGameVersion } from 'app/frontend/base/hooks/useGameVersion'
import NewsTagBadge from 'app/frontend/base/pages/News/NewsTagBadge'
import GuildTeamCard from './GuildTeamCard'

const LinkedGuildTeams = ({
  guild,
  teamData,
}: {
  guild: wowaudit.Guild
  teamData?: GuildTeamData
}) => {
  const gameVersion = useGameVersion()
  const { customDomain } = useCustomDomain()
  const groups = linkedTeamGroups(guild, gameVersion.id, { visibleOnly: true })

  return groups.map(({ linkedGuild, teams, isOtherGameVersion }) => (
    <div key={linkedGuild.id} className='flex flex-col gap-6 text-sm mt-10'>
      <h3 className='flex items-center gap-2 m-0'>
        <span>{linkedGuild.name}</span>
        {isOtherGameVersion ? (
          <NewsTagBadge tag={linkedGuild.gameVersion} />
        ) : null}
      </h3>

      {teams.map((team) => {
        const href = linkedTeamHref(team, {
          isOtherGameVersion,
          onCustomDomain: !!customDomain,
        })
        const { accessLevel } = hasAccessToContent(
          'member',
          'base',
          linkedGuild,
          team,
        )

        return (
          <AuthContext.Provider
            key={team.id}
            value={{ accessLevel, section: 'base', requirement: 'member' }}
          >
            <GuildTeamCard
              team={team}
              href={'external' in href ? href.external : href.internal}
              teamGameVersion={linkedGuild.gameVersion}
              roster={teamData?.[team.id]?.roster}
              eventDays={teamData?.[team.id]?.eventDays}
              medianItemLevel={teamData?.[team.id]?.medianItemLevel}
              raidProgress={teamData?.[team.id]?.raidProgress}
            />
          </AuthContext.Provider>
        )
      })}
    </div>
  ))
}

export default LinkedGuildTeams
